module.exports = __webpack_public_path__ + "static/img/mirror2.56dea10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mirror2.png
// module id = UffT
// module chunks = 2